// extracted by mini-css-extract-plugin
export default {"container":"LO-z","topReviewHeading":"MO-z","criticalReview":"NO-z","favorableReview":"OO-z","vsSeparator":"PO-z"};